

import React, { FC, useRef, useState } from "react";

interface  OTPInputProps {
    length:number;
    onChangeOtp: (otp:any)=>void

}
export const OTPInput:FC<OTPInputProps> = ({ length = 6, onChangeOtp }) => {

  const [otp, setOtp] = useState(new Array(length).fill(""));
  const inputRefs:any = useRef([]);

  const handleChange = (element:any, index:number) => {

    if (isNaN(element.value)) return;

    let newOtp = [...otp];
    newOtp[index] = element.value;
    setOtp(newOtp);

    // move focus to next
    if (element.value !== "" && index < length - 1) {
      inputRefs.current[index + 1].focus();
    }

    // send OTP value to parent
    onChangeOtp(newOtp.join(""));
    
  };

  const handleKeyDown = (e:any, index:number) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  return (
    <div style={{ display: "flex", gap: "8px" }}>
      {otp.map((data, index) => (
        <input
          key={index}
          type="text"
          maxLength={1}
          value={data}
          ref={(el) => (inputRefs.current[index] = el)}
          onChange={(e) => handleChange(e.target, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          style={{
            width: "45px",
            height: "45px",
            textAlign: "center",
            fontSize: "20px",
            border:'1px solid #03a877',
            borderRadius:'5px'
          }}
        />
      ))}
    </div>
  );
};